export var File = globalThis.File;
export var Blob = globalThis.Blob;